module.exports = __webpack_public_path__ + "img/big-pointer--success.bc6667bb.svg";